import { render, staticRenderFns } from "./FoodIconInfoPopup.vue?vue&type=template&id=6c458269&scoped=true&"
import script from "./FoodIconInfoPopup.vue?vue&type=script&lang=js&"
export * from "./FoodIconInfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./FoodIconInfoPopup.vue?vue&type=style&index=0&id=6c458269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c458269",
  null
  
)

export default component.exports